import { mui, React, ts, ui } from '_core';

type BenchmarkTargetSelectorProps = {
  withBenchmark?: boolean;
  benchmark?: ts.types.benchmark.Benchmark;
  setBenchmark?: (_value: ts.types.benchmark.Benchmark) => void;
  setWithBenchmark?: (_value: boolean) => void;
  onlyReturnsLabel?: string;
};

const BenchmarkTargetSelector = ({
  withBenchmark,
  benchmark,
  setBenchmark,
  setWithBenchmark,
  onlyReturnsLabel = 'Returns',
}: BenchmarkTargetSelectorProps) => {
  const getRadioValue = () => {
    if (withBenchmark) return 'benchmark';
    return 'only-returns';
  };

  const [radioValue, setRadioValue] = React.useState(() => getRadioValue());

  React.useEffect(() => {
    const newValue = getRadioValue();
    if (newValue !== radioValue) {
      setRadioValue(newValue);
    }
  }, [withBenchmark]);

  const handleRadioChange = (value: string) => {
    setRadioValue(value);
    if (value === 'benchmark') {
      setWithBenchmark(true);
    } else {
      setWithBenchmark(false);
    }
  };

  return (
    <>
      <mui.core.Box mt={2} ml={1.5}>
        <mui.core.FormControl component="fieldset">
          <mui.core.RadioGroup row value={radioValue} onChange={(e) => handleRadioChange(e.target.value)}>
            <mui.core.FormControlLabel
              value="only-returns"
              control={<mui.core.Radio color="primary" />}
              label={`Only ${onlyReturnsLabel}`}
            />
            <mui.core.FormControlLabel
              value="benchmark"
              control={<mui.core.Radio color="primary" />}
              label="Benchmark"
            />
          </mui.core.RadioGroup>
        </mui.core.FormControl>
      </mui.core.Box>
      {withBenchmark && (
        <mui.core.Box mt={2}>
          <ui.Benchmark
            value={benchmark || undefined}
            setValue={setBenchmark}
            universeContextPath={'$universe.handle'}
            hiddenOptions={[ts.enums.BENCHMARK_TYPES_ENUM.DS_INDEX]}
            universeIdPath={'definition.universe_id'}
          />
        </mui.core.Box>
      )}
    </>
  );
};

export default BenchmarkTargetSelector;
